import { type CardIdentifier as CardIdentifierType } from "@kanpla/api-contract";

import { T } from "@repo/transifex";
import { type Currency } from "~/api/products/types";
import { Avatar } from "~/components/avatar";
import { priceFormatter } from "~/utils/price-formatter";
import { type Language } from "~/api/tills/types";
import { AllergensLabeled } from "~/components/allergens";
import { CardIdentifier } from "~/components/Inputs/card-identifier/card-identifier";

type UserInfoProps = {
  languageCode: Language;
  locale: string;
  currency: Currency;
  name?: string;
  allergens: string[];
  balance?: number | null;
  collectLimit: {
    unitLimitInclVat: number;
    unitAvailableInclVat: number;
  } | null;
  cardIdentifier: CardIdentifierType | null;
  childId: string;
};

export const UserInfo = ({
  name,
  balance,
  collectLimit,
  allergens,
  currency,
  languageCode,
  locale,
  cardIdentifier,
  childId
}: UserInfoProps) => {
  const hasBalanceOrLimit = Boolean(balance || collectLimit);

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3">
      <Avatar name={name} />
      <p className="text-3xl font-extrabold leading-10 text-interface-warning-4">
        {name}
      </p>
      <div className="flex w-full flex-col gap-6">
        <AllergensLabeled
          allergens={allergens}
          languageCode={languageCode}
          className="justify-center"
        />

        <CardIdentifier cardIdentifier={cardIdentifier} childId={childId} />

        {hasBalanceOrLimit ? (
          <div className="flex w-full flex-row items-center justify-center gap-3 rounded-xl bg-yellow-700/5 p-6">
            {typeof balance === "number" ? (
              <div className="flex flex-1 flex-col items-center justify-center gap-2 px-2 py-1">
                <span className="text-2xl font-extrabold text-interface-warning-4">
                  {priceFormatter({
                    value: balance,
                    currency,
                    locale
                  })}
                </span>
                <p className="text-interface-warning-4">
                  <T _str="Balance" />
                </p>
              </div>
            ) : null}
            {collectLimit ? (
              <div className="flex flex-1 flex-col items-center justify-center gap-2">
                <span className="text-2xl font-extrabold text-interface-warning-4">
                  {priceFormatter({
                    value: collectLimit.unitAvailableInclVat,
                    currency,
                    locale
                  })}
                  /
                  {priceFormatter({
                    value: collectLimit.unitLimitInclVat,
                    currency,
                    locale
                  })}
                </span>
                <p className="text-interface-warning-4">
                  <T _str="Available Today" />
                </p>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};
